module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', _vm._b({
    attrs: {
      "value": _vm.value,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.inputHandler
    }
  }, 'el-input', _vm.$attrs, false), [_vm._t("default"), _vm._v(" "), _c('rt-icon', {
    attrs: {
      "slot": "suffix",
      "name": "rt-base-edit"
    },
    slot: "suffix"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68e405a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtInput.vue
// module id = 1402
// module chunks = 96